<div class="body">

    <table mat-table [dataSource]="(items$|async)|sortedObjectArray:active:direction:(items$|async)?.length" class="table" [matSortActive]="active" [matSortDirection]="direction" matSort (matSortChange)="sortData($event)">

        <ng-container matColumnDef="itemproduct">
            <th mat-header-cell mat-sort-header="itemproduct" *matHeaderCellDef>Produkt</th>
            <td mat-cell *matCellDef="let element">

                {{element.value.itemproduct|product|async}}

            </td>
            <td mat-footer-cell *matFooterCellDef class="footer" [attr.colspan]="6">
                {{(items$|async)?.length}} Vertragsartikel
            </td>
        </ng-container>

        <ng-container matColumnDef="itemcontractid">
            <th mat-header-cell mat-sort-header="itemcontractid" *matHeaderCellDef>Vertrag</th>
            <td mat-cell *matCellDef="let element">

                {{element.value.itemcontractid|contract|async}}

            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="itemcount">
            <th mat-header-cell mat-sort-header="itemcount" *matHeaderCellDef>Anzahl</th>
            <td mat-cell *matCellDef="let element">

                {{element.value.itemcount}}

            </td>
            <td mat-footer-cell></td>
        </ng-container>

        <ng-container matColumnDef="itemname">
            <th mat-header-cell mat-sort-header="itemname" *matHeaderCellDef>Bezeichnung</th>
            <td mat-cell *matCellDef="let element">

                {{element.value.itemname}}

            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="itemcanceldate">
            <th mat-header-cell mat-sort-header="itemcanceldate" *matHeaderCellDef>Kündigungsdatum</th>
            <td mat-cell *matCellDef="let element">

                {{element.value.itemcanceldate? (element.value.itemcanceldate|date:'dd.MM.yyyy'): '-'}}

            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="controls">

            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element" class="control-cell">

                <button mat-icon-button (click)="showContract(element.value.itemcontractid)">
                    <mat-icon>search</mat-icon>
                </button>

            </td>
            <td mat-footer-cell *matFooterCellDef></td>

        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: columns;" class="body-row" [class.danger]="row.value.itemcanceldate|beforeYet"></tr>
        <tr mat-footer-row *matFooterRowDef="footerColumns; sticky: true"></tr>

    </table>

</div>
